import { z } from 'zod'
import type { FeatureFlag } from '#/domain/featureFlag/FeatureFlag'

export const FeatureFlagDtoSchema = z
  .object({
    Name: z.string(),
    IsEnabled: z.boolean(),
    Scope: z.string(),
    EntityId: z.string().nullable(),
    Feature: z.string(),
  })
  .transform((raw) => ({
    Name: raw.Name,
    IsEnabled: raw.IsEnabled,
    Scope: raw.Scope,
    EntityId: raw.EntityId,
    Feature: raw.Feature,
  }))

export type FeatureFlagResponseDto = z.input<typeof FeatureFlagDtoSchema>

// The admin feature-flag endpoint returns flags scoped to a single product without
// echoing that product back, so the caller-supplied productName completes the domain shape.
export function toDomain(raw: FeatureFlagResponseDto, product: string): FeatureFlag {
  return { ...FeatureFlagDtoSchema.parse(raw), Product: product }
}

export function toDomainList(raw: FeatureFlagResponseDto[], product: string): FeatureFlag[] {
  return raw.map((item) => toDomain(item, product))
}
